import React, { useEffect, useRef, useState } from "react";
import TelaManutencao from "./TelaManutencao";
import {
  consultarEstadoManutencao,
  lerManutencaoConfirmada,
  guardarManutencaoConfirmada,
} from "./estadoManutencao";

const recarregar = () => window.location.reload();
const storageDaAba = () => { try { return window.sessionStorage; } catch { return null; } };

/** Montado antes da autenticação; a página de aviso é independente da API. */
export default function ManutencaoGate({ children, consultar = consultarEstadoManutencao, aoLiberar = recarregar }) {
  const [ativo, setAtivo] = useState(() => lerManutencaoConfirmada(storageDaAba()));
  const [liberado, setLiberado] = useState(false);
  const [erro, setErro] = useState(false);
  const confirmado = useRef(ativo);

  useEffect(() => {
    let vivo = true;
    let ocupado = false;
    let timer;
    let controlador;
    let timeout;
    let recarregando = false;

    const verificar = async () => {
      if (!vivo || ocupado || recarregando) return;
      ocupado = true;
      controlador = new AbortController();
      timeout = setTimeout(() => controlador.abort(), 4000);
      try {
        const estado = await consultar({ signal: controlador.signal });
        if (!vivo) return;
        if (estado.ativo) {
          confirmado.current = true;
          guardarManutencaoConfirmada(storageDaAba(), true);
          setAtivo(true);
        } else if (confirmado.current) {
          // Uma API antiga, erro ou reinício não prova que a manutenção foi liberada.
          if (estado.legado) throw new Error("Liberação não confirmada");
          guardarManutencaoConfirmada(storageDaAba(), false);
          recarregando = true;
          aoLiberar(); // Carrega a versão publicada e revalida a sessão; nunca reenvia formulários.
        } else {
          setLiberado(true);
        }
        setErro(false);
      } catch {
        if (vivo) setErro(true);
      } finally {
        clearTimeout(timeout);
        ocupado = false;
        if (vivo && !recarregando) timer = setTimeout(verificar, 5000);
      }
    };

    const aoFoco = () => { clearTimeout(timer); verificar(); };
    verificar();
    window.addEventListener("focus", aoFoco);
    return () => {
      vivo = false;
      clearTimeout(timer);
      clearTimeout(timeout);
      controlador?.abort();
      window.removeEventListener("focus", aoFoco);
    };
  }, [consultar, aoLiberar]);

  return (
    <>
      {/* Desmontar também fecha portais de diálogos e encerra os efeitos da sessão. */}
      {liberado && !ativo && children}
      {ativo && <TelaManutencao />}
      {!liberado && !ativo && <div role="status" aria-live="polite" style={{
        minHeight: "100vh", display: "grid", placeItems: "center", padding: 24,
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif', textAlign: "center",
      }}>
        {erro ? "Não foi possível verificar a disponibilidade do SEAR. Tentando novamente…" : "Verificando disponibilidade do SEAR…"}
      </div>}
    </>
  );
}
